"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgLike64 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M0 .5h64v64H0z" }), (0, jsx_runtime_1.jsx)("path", { d: "M20.962 31.034 27.17 13.61s4.563-.118 4.563 5.193v9.736h15.644a3.655 3.655 0 0 1 3.733 3.481 3.496 3.496 0 0 1-.855 2.28 3.512 3.512 0 0 1 1.727 3.385 3.52 3.52 0 0 1-2.37 2.975c.64.941.785 2.132.39 3.199a3.535 3.535 0 0 1-2.385 2.178c.788.749 1.04 1.9.634 2.906a2.662 2.662 0 0 1-2.474 1.664H31.733a25.875 25.875 0 0 1-10.8-2.166M12 29.5h9v20h-9v-20Z", strokeLinecap: "square", stroke: "currentColor" })] })) }))); };
exports.default = SvgLike64;
